import script from "./MasterInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./MasterInfo.vue?vue&type=script&lang=ts&setup=true"

import "./MasterInfo.vue?vue&type=style&index=0&id=3d3de427&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d3de427"]])

export default __exports__